// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"83990f3e","415":"1bc9e964","724":"6e0896d2","900":"5b2b8463"}[chunkId] + ".chunk.js";
};